export class BinLocationModel {
    public nsuk: number;
    public location: number;
    public parent: number;
    public locationTag: string;
    public note: string;
}